export enum BaseRoutes {
  CHS_API = '/app/casa/historial-crediticio/',
}
